import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getOrganizationList } from "../../services/admin/organization";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../ui/select";
import styles from "./AccountSelector.module.css";

const AccountSelector = ({ value, onChange }) => {
  const { data: organizations, isLoading } = useQuery(
    ["organizations-list"],
    () => getOrganizationList(),
    { staleTime: 5 * 60 * 1000 }
  );

  const options = useMemo(() => {
    const orgOptions = (organizations || []).map((org) => ({
      id: org.id,
      name: org.name,
      scope: org.schema_name || "all",
    }));

    return [{ id: "all", name: "All Accounts", scope: "all" }, ...orgOptions];
  }, [organizations]);

  const selectedScope = value?.scope || "all";
  const selectedName = value?.name || "All Accounts";

  const handleSelect = (scope) => {
    const next = options.find((opt) => opt.scope === scope) || options[0];
    onChange(next);
  };

  return (
    <div className={styles.accountSelector}>
      <span className={styles.label}>Account:</span>
      <Select value={selectedScope} onChange={handleSelect} className={styles.select}>
        <SelectTrigger className={styles.trigger}>
          <SelectValue placeholder="All Accounts">{selectedName}</SelectValue>
        </SelectTrigger>
        <SelectContent className={styles.content}>
          {isLoading ? (
            <div className={styles.loading}>Loading...</div>
          ) : (
            options.map((opt) => (
              <SelectItem key={opt.id} value={opt.scope}>
                {opt.name}
              </SelectItem>
            ))
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

export default AccountSelector;
